export const page = "p-4 sm:p-6 max-w-7xl mx-auto";

export const pageFill = "flex flex-col h-[calc(100vh-4rem)]";

export const stickyHeader = "sticky top-0 z-10 bg-background border-b border-border/60 px-4 md:px-6 py-3 shrink-0";

export const rowGap1 = "flex items-center gap-1";

export const rowGap2 = "flex items-center gap-2";

export const rowGap3 = "flex items-center gap-3";

export const rowBetween = "flex items-center justify-between";

export const rowCenter = "flex items-center justify-center";

export const colCenter = "flex flex-col items-center justify-center";

export const flexTruncate = "flex-1 min-w-0";

export const muted = "text-sm text-muted-foreground";

export const mutedXs = "text-xs text-muted-foreground";

export const mutedBase = "text-muted-foreground";

export const titleSm = "text-sm font-medium text-foreground";

export const titleSmSemibold = "text-sm font-semibold text-foreground";

export const headingLg = "text-lg font-semibold text-foreground";

export const sectionHeading = "text-lg font-semibold mb-4 flex items-center gap-2 text-foreground";

export const sectionCard = "rounded-xl border border-border bg-card shadow-card p-4 sm:p-6 transition-all duration-200 hover:border-primary/30";

export const iconXs = "h-3.5 w-3.5";

export const iconSm = "h-4 w-4";

export const iconMd = "h-5 w-5";

export const iconPrimary = "text-primary";

export const iconMuted = "text-muted-foreground";

export const transitionDefault = "transition-all duration-200";

export const transitionColors = "transition-colors duration-200";

export const inputBase =
  "w-full rounded-lg border border-input bg-background px-3 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:border-ring focus:outline-none focus:ring-2 focus:ring-ring/20 transition-all duration-200";

export const inputIcon = "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none";

export const primaryButton =
  "rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm transition-all duration-200 hover:bg-primary/90 active:scale-[0.98]";

export const secondaryButton =
  "rounded-lg border border-border px-4 py-2.5 text-sm font-medium text-muted-foreground hover:bg-accent transition-all duration-200 active:scale-[0.98]";

export const iconButton =
  "inline-flex items-center justify-center rounded-lg p-2 text-muted-foreground hover:bg-accent hover:text-foreground transition-all duration-150 active:scale-95";

export const dialogOverlay = "fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 animate-fade-in";

export const dialog = "w-full max-w-lg rounded-xl border border-border bg-card shadow-elevated animate-scale-in";

export const emptyState = "flex flex-col items-center justify-center py-16 text-center animate-scale-in";

export const errorBox = "rounded-lg border border-destructive/20 bg-destructive/5 px-3 py-2.5 text-sm text-destructive flex items-center gap-2";

export const errorText = "text-sm text-destructive";

export const formStack = "space-y-3";

export const skeleton = "animate-shimmer rounded-xl bg-muted/50 transition-all duration-200";

export const animateSlideUp = "animate-slide-up";

export const centerScreen = "flex min-h-screen items-center justify-center bg-background";

export const authPage = "relative flex min-h-screen items-center justify-center bg-background overflow-hidden";

export const authCard = "w-full max-w-md animate-scale-in";

export const authBranding = "mb-6 flex flex-col items-center text-center";

export const authLogo = "mb-4 flex h-14 w-14 items-center justify-center rounded-2xl gradient-brand shadow-md";

export const authLogoIcon = "h-8 w-8 text-white";

export const authTitle = "text-3xl font-extrabold tracking-tight text-foreground";

export const authSubtitle = "mt-1.5 text-sm text-muted-foreground";

export const authForm = "space-y-4";

export const authError = "mb-4 flex items-center gap-2 rounded-lg bg-destructive/10 p-3 text-sm text-destructive animate-slide-up";

export const authSubmit = "w-full";
